import React from 'react';
import {allApplications} from '../applications/ApplicationList.js';
import '../desktop-components-css/StartMenu.css';

class StartMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: this.props.status
    }
    this.createClickBoundary = this.createClickBoundary.bind(this);
    document.addEventListener('mousedown', this.clickHandler);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.clickHandler);
  }

  clickHandler = (e) => {
    if(this.clickBoundary && !this.clickBoundary.contains(e.target)) {
      this.props.startButtonHandler();
    }
  }

  createClickBoundary(node) {
    this.clickBoundary = node;
  }

  render() {
    if(!this.props.status) {
      return null;
    }
    return (
      <div id="startMenu" ref={this.createClickBoundary}>
        {allApplications.map((value, index) => {
          if(value.windowType === "Application") {
            let buttonTitle = "start-" + value.name
            return (
              <button
                data-testid = {buttonTitle}
                onClick = {e => this.props.appLauncherHandler(e, value.name)}
                key = {index}>
                  <div id="buttonContents">
                    <img src={value.smallIcon} draggable="false" alt={value}/>
                    <div id="buttonText">{value.name}</div>
                  </div>
              </button>
            );
          }
          else {
            return(null);
          }
        })}
      </div>
    );
  }

}

export default StartMenu;
